import { render, staticRenderFns } from "./ClientDetailsDrawer.vue?vue&type=template&id=5dcf5001"
import script from "./ClientDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./ClientDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports